import { Breadcrumbs as BreadcrumbsUI, BreadcrumbItem } from '@heroui/breadcrumbs';
import { useNavigate } from 'react-router-dom';

interface BreadcrumbsProps {
  items: { href: string; value: string }[];
}

function Breadcrumbs({ items }: BreadcrumbsProps) {
  const navigate = useNavigate();

  return (
    <BreadcrumbsUI>
      {items.map((i) => (
        <BreadcrumbItem
          key={i.href}
          onPress={() => navigate(i.href)}
        >
          {i.value}
        </BreadcrumbItem>
      ))}
    </BreadcrumbsUI>
  );
}

export default Breadcrumbs;
